$(function(){
  //共通パーツ流し込み処理
  $('.top_nav').load('/en/module/html/gnav_top.html', function(data, status) {
    if(status === 'success') {
      //通常のクリック時
      $('#nav-shop > a[href^="#"]').click(function(event) {
        //スクロール実行
        var target = $('#shoplist');
        var position = target.offset().top;
        var navHeight = $('.nav_fix').height() + 60;
        $('body,html').animate({scrollTop:position - navHeight}, 600);
        return false;
      });
    }
  });
  $('.subpage_nav').load('/en/module/html/gnav.html');
  $('.link').load('/en/module/html/link.html');
  $('.footer').load('/en/module/html/footer.html');

  //URLのハッシュ値を取得
  var urlHash = location.hash;
  //ハッシュ値があればページ内スクロール
  if(urlHash) {
    scrollToAnker(urlHash);
  }
  // 関数：スムーススクロール
  // 指定したアンカー(#ID)へアニメーションでスクロール
  function scrollToAnker(urlHash) {
    var target = $(urlHash);
    var position = target.offset().top;
    var navHeight = $('.nav_fix').height() + 60;
    $('body,html').animate({scrollTop:position - navHeight}, 600);
    return false;
  }
});

setTimeout(sitestart, 5000);

function sitestart(){
$('#loader-bg').delay(800).fadeOut(1000);
}
function setMvRipples01(){
try {
  $('.mv_01').ripples({
    resolution: 600,
    dropRadius: 20, //px
    perturbance: 0.003,
  });
}
catch (e) {
  $('.error').show().text(e);
}
//jQuery Ripples END
};
function setMvRipples02(){
try {
  $('.mv_02').ripples({
    resolution: 600,
    dropRadius: 20, //px
    perturbance: 0.003,
  });
}
catch (e) {
  $('.error').show().text(e);
}
//jQuery Ripples END
};
function setMvRipples03(){
try {
  $('.mv_03').ripples({
    resolution: 600,
    dropRadius: 20, //px
    perturbance: 0.003,
  });
}
catch (e) {
  $('.error').show().text(e);
}
//jQuery Ripples END
};
function setRipples(){
try {
  $('#about .mizumachi').ripples({
    resolution: 1000,
    dropRadius: 30, //px
    perturbance: 0.003,
  })
}
catch (e) {
  $('.error').show().text(e);
}
//jQuery Ripples END
};

$(window).on('load', function(){
// スマホとタブレットでviewportを切替え
var ua = navigator.userAgent;
if (ua.indexOf("iPhone") >= 0 || ua.indexOf('Android') >= 0 ) {
  $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
}
// else if (ua.indexOf("iPad") >= 0|| navigator.userAgent.indexOf("iPod") >= 0) {
//  $('head').prepend('<meta name="viewport" content="width=1200">');
// }
  else {
    $('head').prepend('<meta name="viewport" content="width=1200">');
    // $('html,body').animate({ scrollTop: 0 }, '1');
    //jQuery Ripples
    setMvRipples01();
    setTimeout(setMvRipples02, 500);
    setTimeout(setMvRipples03, 1000);
    setRipples();
  }
//android hack
  if(ua.indexOf('Android') > 0){
    $("html").addClass("android");
  }
  sitestart();

  $('.mv-slider').slick({
    arrows : false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 2000,
    fade: true,
    draggable : false,
    pauseOnHover : false,
    zIndex: 1
  });
});


$('.btn_toggle').click(function() {
  $(this).next('dd').slideToggle();
  $(this).toggleClass('open');
});